"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselNav: function() {
        return _index.TeachingPopoverCarouselNav;
    },
    renderTeachingPopoverCarouselNav_unstable: function() {
        return _index.renderTeachingPopoverCarouselNav_unstable;
    },
    teachingPopoverCarouselNavClassNames: function() {
        return _index.teachingPopoverCarouselNavClassNames;
    },
    useTeachingPopoverCarouselNavStyles_unstable: function() {
        return _index.useTeachingPopoverCarouselNavStyles_unstable;
    },
    useTeachingPopoverCarouselNav_unstable: function() {
        return _index.useTeachingPopoverCarouselNav_unstable;
    }
});
const _index = require("./components/TeachingPopoverCarouselNav/index");
